import { SVG, getDefaultHeight } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const NewWindowIcon: React.FC<Props> = ({
  color = "currentColor",
  ...svgProps
}) => {
  return (
    <SVG
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 18)}
      strokeWidth="1.7"
      {...svgProps}
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke={color}
      viewBox="0 0 20.277 20.277"
    >
      <path d="M19.076 6.67V1.202h-5.469M19.075 1.202l-12.15 12.15M9.355 4.847h-7.29A1.215 1.215 0 00.85 6.062v12.15a1.215 1.215 0 001.215 1.215h12.15a1.215 1.215 0 001.215-1.215v-7.29" />
    </SVG>
  );
};
